import { AgTechTourConfig } from '@agtech/web/components/App/Tour/AgTechTourTypes'

export const InvoiceEditPaymentDialogTourConfig: AgTechTourConfig = {
    id: 'invoice-edit-payment-dialog-tour',
    name: 'Edit Payment Tour',
    steps: [
        {
            targetId: 'invoice-edit-payment-payer',
            title: 'Payer and Amount',
            description: 'Correct who made the payment or the amount that was paid.',
            position: 'bottom',
        },
        {
            targetId: 'invoice-edit-payment-type',
            title: 'Payment Type and Details',
            description: 'Change how the payment was made or update its details, such as a check number. Click Save to apply your changes.',
            position: 'bottom',
        },
    ]
}
